// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const ENFORCEMENT_CASE_STAGES = [
    'intake',
    'responding',
    'decision',
    'corrective_measures',
    'closed',
];
export const ENFORCEMENT_INTAKE_KINDS = ['inspection_notice', 'violation_record'];
export const ENFORCEMENT_CASES_COLLECTION = 'grc_enforcement_cases';
export const ENFORCEMENT_CASE_ERROR_CODES = {
    NOT_FOUND: 'ENFORCEMENT_CASE_NOT_FOUND',
    INVALID_TRANSITION: 'ENFORCEMENT_CASE_INVALID_TRANSITION',
    MEASURE_EVIDENCE_REQUIRED: 'ENFORCEMENT_CASE_MEASURE_EVIDENCE_REQUIRED',
    CLOSED_IMMUTABLE: 'ENFORCEMENT_CASE_CLOSED_IMMUTABLE',
};
//# sourceMappingURL=enforcement-case.js.map